import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center transition-all duration-300 font-sans tracking-wide focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-400 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-accent-400 text-white hover:bg-accent-500 shadow-sm font-semibold',
    secondary: 'bg-ink-900 text-sage-50 hover:bg-ink-800 shadow-sm',
    outline: 'border border-accent-400/60 text-accent-500 hover:bg-accent-400 hover:text-white hover:border-accent-400',
    ghost: 'text-ink-900 hover:text-accent-500 hover:bg-sage-200/50'
  };
  const sizes = {
    sm: 'text-xs px-4 py-2 uppercase tracking-wider',
    md: 'text-sm px-6 py-3 uppercase tracking-wider',
    lg: 'text-base px-8 py-4 uppercase tracking-widest'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-485">
      {children}
    </motion.button>;
}